module.exports = __webpack_public_path__ + "static/media/RVS-logo.9ed76aeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/RVS-logo.svg
// module id = 912
// module chunks = 0